import Config from '../../../../config';
import FetchApi from '../../../../core/fetch/FetchApi';
import generateValidUrl from '../../../../core/fetch/generateValidUrl';
import { HttpMethods } from '../../../../core/fetch/HttpMethod';
import formatRequestBody from '../../../../temp/formatRequestBody';
import { IPwaClientSyncRequest, IPwaClientSyncResult } from '../types';
import { parsePwaClientResponse } from '../utils/parsePwaClientResponse';

export interface IReportPwaClientDeps {
    fetchFn?: typeof FetchApi.fetch;
}

/**
 * Tells PHP (`set_pwa_client`) whether this session runs in the browser or in
 * the installed PWA. Updates user.last_client (+ last_pwa_open_at for 'pwa').
 */
export async function reportPwaClient(
    request: IPwaClientSyncRequest,
    deps: IReportPwaClientDeps = {}
): Promise<IPwaClientSyncResult> {
    const fetchFn = deps.fetchFn ?? FetchApi.fetch.bind(FetchApi);

    try {
        const response = await fetchFn(
            generateValidUrl(Config.BASE_URL),
            formatRequestBody(Config.SET_PWA_CLIENT_URL, request.user.Userid, {
                client: request.client,
            }),
            HttpMethods.POST,
            request.token,
            request.user
        );

        const payload = await response.json();
        return parsePwaClientResponse(payload);
    } catch {
        return { status: 'error', note: 'NetworkError' };
    }
}
